import * as AuthInfo from './auth/info/index.js'
import * as Events from './events/index.js'
import * as EventsReset from './events/reset/index.js'
import { HttpClient } from './httpClient.js'
import * as Links from './links/index.js'
import * as Participants from './participants/index.js'
import * as Seasons from './seasons/index.js'
import * as Skins from './skins/index.js'
import * as Sport from './sport/index.js'
import * as Venues from './venues/index.js'

export type SportsApiClient = ReturnType<typeof createSportsApiClient>

/**
 * Api endpoints for authenticated user.
 *
 * Requires client with token received after successful logIn.
 */
// implicit TypeScript return type - to avoid unnecessary boilerplate
//
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export function createSportsApiClient(httpClient: HttpClient) {
  // client - first argument auto-provided to exposed methods
  const sportsApiClient = {
    AuthInfo: {
      get: AuthInfo.get.bind(null, httpClient),
    },
    Events: {
      // TODO: create helper function "bindHttpClient", replace ".bind(null, httpClient)"
      reset: EventsReset.reset.bind(null, httpClient),
      getById: Events.getById.bind(null, httpClient),
      patch: Events.patch.bind(null, httpClient),
      IncidentsQueue: {
        delete: Events.IncidentsQueue.delete.bind(null, httpClient),
        patch: Events.IncidentsQueue.patch.bind(null, httpClient),
        post: Events.IncidentsQueue.post.bind(null, httpClient),
      },
      Incidents: {
        get: Events.Incidents.get.bind(null, httpClient),
        post: Events.Incidents.post.bind(null, httpClient),
        Swap: {
          post: Events.Incidents.Swap.post.bind(null, httpClient),
        },
        Occurs: {
          post: Events.Incidents.Occurs.post.bind(null, httpClient),
        },
      },
      KeepAlive: {
        post: Events.KeepAlive.post.bind(null, httpClient),
      },
      SwappableIncidents: {
        get: Events.SwappableIncidents.get.bind(null, httpClient),
      },
      SubParticipants: {
        get: Events.SubParticipants.get.bind(null, httpClient),
        patch: Events.SubParticipants.patch.bind(null, httpClient),
      },
      SubParticipantsSave: {
        post: Events.SubParticipantsSave.post.bind(null, httpClient),
      },
      Participants: {
        get: Events.Participants.get.bind(null, httpClient),
        patch: Events.Participants.patch.bind(null, httpClient),
        Lineups: {
          clearLineup: Events.Participants.Lineups.clearLineup.bind(
            null,
            httpClient,
          ),
        },
      },
      Scouts: {
        get: Events.Scouts.get.bind(null, httpClient),
      },
    },
    Links: {
      get: Links.get.bind(null, httpClient),
    },
    Participants: {
      Squad: {
        getBySeasonId: Participants.Squad.getBySeasonId.bind(null, httpClient),
      },
      get: Participants.get.bind(null, httpClient),
      getById: Participants.getById.bind(null, httpClient),
    },
    Seasons: {
      Details: {
        getBySeasonId: Seasons.Details.getBySeasonId.bind(null, httpClient),
      },
    },
    Sport: {
      get: Sport.getById.bind(null, httpClient),
    },
    Skins: {
      getForParticipant: Skins.getForParticipant.bind(null, httpClient),
    },
    Venues: {
      get: Venues.get.bind(null, httpClient),
      getById: Venues.getById.bind(null, httpClient),
    },
  }

  return sportsApiClient
}
